import React, { Component } from 'react';

import ComplexPartner from './complexPartner';

const steps = {
	initial: 0,
	set_api_data: 0,
	set_customer_id: 1,
	set_auth_link: 1,
	set_api_mask: 1,
	trigger_synchro_booking: 1,
	success: 2,
};

const Kouver = props => {
	return (
		<ComplexPartner
			key_={props.key_}
			index={props.index}
			setBlurBackground={props.setBlurBackground}
			steps={steps}
		/>
	);
};

export default Kouver;
